import { FLYBITS, HEADERS } from '../constants';
import { IApp, IProject } from '../types/app';
import axios from '../utils/axios';

export const getProjects = async (session: string, apiHost): Promise<IProject[]> => {
    const response = (await axios.get(apiHost + '/kernel/projects?min=20&max=1000000&limit=1000000', {
        headers: {
            'x-authorization': session,
        }
    }));
    let projects;
    if (200 === response.status) {
        projects = response.data.data;
    } 
    return projects || [];
}

export const getConsentedProjects = async (session: string, apiHost): Promise<string[]> => {
    const response = (await axios.get(FLYBITS.IDP_HOST + '/management/tenants/consent', {
        headers: {
            Authorization: session,
            [HEADERS.X_API_HOST]: apiHost,
        },
    }));
    let projects;
    if (200 === response.status) {
        projects = response.data;
    } 
    return projects || [];
}


export const loadApp = (): IApp => ({
    projects: [],
    consentedProjects: [],
    apiHost: FLYBITS.FLYBITS_HOST,
})



// WEBPACK FOOTER //
// ./src/services/app.ts